
import React, { useState, useEffect } from "react";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css"; // Import Bootstrap CSS

const App = () => {
  const [url, setUrl] = useState("");
  const [formats, setFormats] = useState([]);
  const [thumbnail, setThumbnail] = useState("");
  const [videoTitle, setVideoTitle] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [countdown, setCountdown] = useState(5); // Countdown state
  const [activeTab, setActiveTab] = useState("video"); // Active tab state

  useEffect(() => {
    let timer;
    if (loading) {
      setCountdown(5); // Reset countdown to 5 seconds
      timer = setInterval(() => {
        setCountdown((prev) => (prev > 1 ? prev - 1 : 0));
      }, 1000);
    } else {
      clearInterval(timer);
    }
    return () => clearInterval(timer);
  }, [loading]);

  // Fetch formats based on YouTube URL
  const fetchFormats = async () => {
    setError("");
    setFormats([]);
    setThumbnail("");
    setVideoTitle("");

    if (!url) {
      setError("Please enter a valid YouTube URL.");
      return;
    }

    try {
      setLoading(true);
      const response = await axios.post("https://ytd.mhnazmul.com/getFormats", { url });
      setFormats(response.data.formats);
      setThumbnail(response.data.thumbnail);
      setVideoTitle(response.data.videoTitle);
    } catch (err) {
      setError("Error fetching video formats.");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleDownload = (type, itag) => {
    const downloadUrl = `https://ytd.mhnazmul.com/download${type}?url=${encodeURIComponent(
      url
    )}&itag=${itag}`;
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.setAttribute("download", "");
    document.body.appendChild(link);
    link.click();
    link.remove();
  };
console.log(formats);

  return (
    <div className="container">
      <div className="">
        <div className="card-body text-center">
        
      {/* Input and Button */}
      <form className="row mx-auto m-5 g-3 justify-content-center align-items-center" style={{maxWidth:"800px" }}>
  {/* Input Field */}
  <div className="col-12 col-md-10">
    <div className="input-group" style={{ height: "60px" }}>
      {/* YouTube Icon */}
      <span
        className="input-group-text bg-light"
        style={{
          borderRight: "0", // Removes the right border
          display: "flex",
          alignItems: "center",
        }}
      >
        <img
          src="https://img.icons8.com/color/48/000000/youtube-play.png"
          alt="YouTube Icon"
          style={{ width: "48px", height: "48px" }}
        />
      </span>
      {/* Input Box */}
      <input
        type="text"
        className="form-control"
        placeholder="https://www.youtube.com/watch?v=..."
        value={url}
        onChange={(e) => setUrl(e.target.value)}
        style={{
          backgroundColor: "#f7f9fc",
          border: "1px solid #d9dfe7",
          borderLeft: "0", // Removes the left border between icon and input
          fontSize: "1rem",
          padding: "0.8rem 1rem",
          borderRadius: "0 5px 5px 0", // Rounded corners for right side
        }}
      />
    </div>
  </div>

  {/* Search Button */}
  <div className="col-12 col-md-2">
    <button
      type="button"
      className="btn w-100"
      onClick={fetchFormats}
      disabled={loading}
      style={{
        backgroundColor: "#5b4ee6",
        color: "#fff",
        fontSize: "1rem",
        padding: "0.7rem 1.5rem",
        height: "60px",
        borderRadius: "5px",
      }}
    >
      {loading ? `Loading... ${countdown}s` : "Search"}
    </button>
  </div>
</form>
          {error && (
            <div className="alert alert-danger mt-3" role="alert">
              {error}
            </div>
          )}

          {thumbnail && (
            <div className="mx-auto" style={{maxWidth:"800px" }}>
              <img
                src={thumbnail}
                alt="Video Thumbnail"
                className="img-fluid rounded shadow"
                style={{
                  maxHeight: "300px",
                  objectFit: "cover",
                  width: "100%",
                  borderRadius: "0.5rem",
                }}
              />
              <h3 className="m-3">{videoTitle}</h3>
            </div>
          )}

{formats.length > 0 && (
  <div className="mx-auto" style={{maxWidth:"800px" }}>
    {/* Tabs for Video and Audio */}
    <ul className="nav nav-tabs justify-content-center" role="tablist">
      <li className="nav-item">
        <button
          className={`nav-link ${activeTab === "video" ? "active" : ""}`}
          onClick={() => setActiveTab("video")}
        >
          Video
        </button>
      </li>
      <li className="nav-item">
        <button
          className={`nav-link ${activeTab === "audio" ? "active" : ""}`}
          onClick={() => setActiveTab("audio")}
        >
          Audio
        </button>
      </li>
    </ul>

    {/* Tab Content */}
    <div className="tab-content mt-3">
      {/* Video Formats */}
      {activeTab === "video" && (
        <div>
          <h5 className="text-center mb-4">Available Video Formats</h5>
          {formats
            .filter((format) => format.type === "video") // Only video formats
            .map((format, index) => (
              <div
                key={index}
                className="d-flex mx-auto justify-content-between align-items-center p-3 border-bottom"
                style={{
                  fontSize: "1.2rem",
                  fontWeight: "500",
                  minHeight: "60px",
                }}
              >
                {/* Format Label */}
                <span>{`${format.qualityLabel} (mp4)`}</span>

                {/* Download Button */}
                <button
                  className="btn btn-success"
                  onClick={() => handleDownload("Video", format.itag)}
                  style={{
                    backgroundColor: "#5b4ee6",
                    color: "#fff",
                    fontSize: "1rem",
                    padding: "0.6rem 1.5rem",
                    borderRadius: "5px",
                  }}
                >
                  Download
                </button>
              </div>
            ))}
        </div>
      )}

      {/* Audio Formats */}
      {activeTab === "audio" && (
        <div>
          <h5 className="text-center mb-4">Available Audio Formats</h5>
          {formats
            .filter((format) => format.type === "audio") // Only audio formats
            .map((format, index) => (
              <div
                key={index}
                className="d-flex justify-content-between align-items-center p-3 border-bottom"
                style={{
                  fontSize: "1.2rem",
                  fontWeight: "500",
                  minHeight: "60px",
                }}
              >
                {/* Format Label */}
                <span>{`Audio (mp3)`}</span>

                {/* Download Button */}
                <button
                  className="btn btn-success"
                  onClick={() => handleDownload("Audio", format.itag)}
                  style={{
                    backgroundColor: "#5b4ee6",
                    color: "#fff",
                    fontSize: "1rem",
                    padding: "0.6rem 1.5rem",
                    borderRadius: "5px",
                  }}
                >
                  Download
                </button>
              </div>
            ))}
        </div>
      )}
    </div>
  </div>
)}




        </div>
      </div>
    </div>
  );
};

export default App;
